<template>
  <div class="background">
    <service ref="service" />
    <main class="contents">
      <h1 class="text" v-if="count.actionable !== 0 && !this.$store.state.isReadOnly">
        <span class="regular">
          {{ $t("you_have") }}
        </span><br>
        <span class="large">
          {{ text.heading }}
        </span><br>
        <span class="regular">
          {{ text.subheading }}
        </span>
      </h1>

      <h1 class="text" style="font-size: 1em;" v-if="count.actionable === 0">
        {{ $t("your_vehicle_inspected")}}
      </h1>

      <figure class="card">
        <img
          class="avatar"
          :src="advisor.advisorImageUrl"
        >
        <figcaption>
          <span>
            {{ $t("your_service_advisor") }}
          </span>
          <span
            class="consultant__name"
          >
            {{ advisor.advisorName }}
          </span>
        </figcaption>
      </figure>
       <div class = "item" v-if="inspectionReportUrl">
         <img
            src="@/assets/images/pdf_icon.png"
            alt="clipboard"
            class="icon">
            <a class="text" @click="viewInspectionReport()">
            {{ $t("inspection_Report") }}
            </a>
       </div>
       <p class="inspectionText" v-if="thumbNail !== null && thumbNail.length !== 0">
          {{ $t("inpection_Level_Media_Heading") }}
      </p>
    <!-- <div
        class="bottom"
        @click="openService()"
        v-if="inspectionLevelMediaUrls"
      >
        <img
          :src="thumbNail"
          class="image"
        >
    </div> -->
    <div id="slider" v-if="thumbNail != null && thumbNail.length !== 0">  
     <span class = "left-arrow" @click.prevent="prevSlide" v-bind:class= "visibiltyLeftArrow" ></span>
      <div class="slider">
      <ul v-if="typeof thumbNail[0] === 'string'" class="slides" id = "imageSliderWidth" :style="{ left: -width * current + 'px' }">
        <li v-for="(slide, i) in thumbNail" v-bind:key="i">
          <img v-if="!isVideo(slide)" class="media-service" :src="slide" :alt="slide" @click="openService(slide)">
          <video v-if="isVideo(slide)" class="media-service" :src="slide" :alt="slide" @click="openService(slide)" playsinline></video>
        </li>
      </ul>
      <ul v-else class="slides" id = "imageSliderWidth" :style="{ left: -width * current + 'px' }">
        <li v-for="(slide, i) in thumbNail" v-bind:key="-i">
          <img v-if="!isVideo(slide.thumbnailUrl)" class="media-service" :src="slide.thumbnailUrl" :alt="slide.thumbnailUrl" @click="openServiceInner(slide.thumbnailUrl, i)">
          <video v-if="isVideo(slide.thumbnailUrl)" class="media-service" :src="slide.thumbnailUrl" :alt="slide.thumbnailUrl" @click="openServiceInner(slide.thumbnailUrl, i)" playsinline></video>
        </li>
      </ul>
    </div>
    <span class = "right-arrow" @click.prevent="nextSlide" v-bind:class = "visibiltyRightArrow"></span>
   </div>

   <div class = "slide-number" v-if="(thumbNail != null && thumbNail.length !== 0)">
      {{current+1}}/{{ thumbNail.length}}
   </div>



      <template
        v-if="timer.total > 0 && !this.$store.state.isReadOnly"
      >
        <p class="text">
          {{ $t("select_your_services_in") }}
        </p>
        <p
          v-if="timer.total"
          class="text time"
        >
          <span
            v-if="timer.days"
            class="unit"
          >
            <span class="number">
              {{ timer.days }}
            </span>d
          </span>
          <span
            class="unit"
          >
            <span class="number">
              {{ timer.hours }}
            </span>h
          </span>
          <span
            class="unit"
          >
            <span class="number">
              {{ timer.minutes }}
            </span>
          </span>
          <span
            class="unit"
          >
            <span class="number">
              {{ timer.seconds }}
            </span>s
          </span>
        </p>
        <p class="text">
          {{ $t("to_have_your_vehicle_ready_by") }}
        </p>

        <div class="card">
          <div class="clock__background">
            <img
              class="clock"
              src="@/assets/images/clock.svg"
              aria-hidden="true"
            >
          </div>
          <p
            class="text pickup__time"
          >
            {{ getPickupTime() }}
          </p>
        </div>
      </template>
      <p class="inspectionText" v-if="count.actionable === 0">
          {{ $t("thank_You_for_chosing") + " " + dealer.name + " " + $t("for_your_service_need") }}
      </p>
      <button
        class="button cta"
        @click="inspectionRoute()"
      >
        {{ count.actionable === 0 ? "OK"  :  text.button }}
      </button>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
import Service from '@/components/Service.vue'
import fallbackThumbnail from '@/assets/images/fallback-thumbnail.png'
  export default Vue.extend({
    components: {
      Service
    },
    data: () => ({
      open: false,
      current: 0,
      width: 200,
      timer: {
        'total': 0,
        'days': 0,
        'hours': 0,
        'minutes': 0,
        'seconds': 0
      }
    }),
    computed: {
      ...mapState([
        'drawer',
        'advisor',
        'inspectionLevelMediaUrl',
        'inspectionLevelMediaUrls',
        'inspectionLevelMedia',
        'dealer',
        'inspectionReportUrl',
        'service'
      ]),
      ...mapGetters([
        'readyBy',
        'respondBy',
        'count',
        'totalEstimateCount'
      ]),
    totalCount () {
        return this.count.actionable
      },
    text () {
        return {
          heading: `${this.totalEstimateCount} ${this.$tc('items', this.totalEstimateCount)}`,
          subheading: this.$tc('that_need_your_attention', this.totalEstimateCount),
          button: this.$tc('review_items', this.totalEstimateCount)
        }
      },
      visibiltyLeftArrow() {
      return this.current+1 > 1 ? 'visibilty-yes' : 'visibility-no';
      },
      visibiltyRightArrow() {
      return this.current+1 < this.thumbNail.length ? 'visibilty-yes' : 'visibility-no';
      },
      thumbNail () {
        if (this.inspectionLevelMedia != null) {
          return this.inspectionLevelMedia;
        }
        if (this.inspectionLevelMediaUrls) {
          let thumbnailUrls = [];
          this.inspectionLevelMediaUrls.forEach((element, i) => {
            let fullUrl = element.split(';');
            thumbnailUrls.push(fullUrl[0]);
          });
          return thumbnailUrls;
        }
        let imageURL = this.inspectionLevelMediaUrl;
        if (imageURL) {
          let imageArray = String(imageURL).split(';');
          if (imageArray.length > 1) {
            return [imageArray[0]]
          }
        }
        return String(fallbackThumbnail).split(';');
      }
  },
  created () {
    this.timer = this.getTimeRemaining()
    this.startTimer()
  },
  beforeDestroy () {
    this.logEvent('Finished viewing at a glance page')
  },
  methods: {
    ...mapActions([
      'viewService',
      'viewServiceInner',
      'getTax',
      'getMetadata'
      ]),
    getPickupTime () {
      const now = new Date()
      const today = this.readyBy.getFullYear() === now.getFullYear() && this.readyBy.getMonth() === now.getMonth() && this.readyBy.getDate() === now.getDate()

      if (today) {
        return `${this.$t('today')} ${this.$t('at')} ${this.$d(this.readyBy, 'time')}`
      } else {
        return `${this.$d(this.readyBy, 'dateAndTime')}`
      }
    },
    // visibiltyClass() {
    //   return this.current+1 > 1 ? 'visibilty-yes' : 'visibility-no';
    // },
    getTimeRemaining () {
      let total = this.respondBy - Date.now()
      let days = Math.floor(total / (1000 * 60 * 60 * 24))
      let hours = Math.floor((total / (1000 * 60 * 60)) % 24)
      let minutes = Math.floor((total / 1000 / 60) % 60)
      let seconds = Math.floor((total / 1000) % 60)
      return {
        total,
        days,
        hours,
        minutes,
        seconds
      }
    },
    startTimer () {
      let timeInterval = setInterval(() => {
        // end contition
        if (this.timer.total <= 0) {
          clearInterval(timeInterval)
          this.timer.days = 0
          this.timer.hours = 0
          this.timer.minutes = 0
          this.timer.seconds = 0
        }
        this.timer = this.getTimeRemaining()
      }, 1000)
    },
    openService (x) {     
      this.viewService(x);
    },
    openServiceInner (x, i) {
      this.viewServiceInner({ service: x, mediaIndex: i });
    },
    isVideo (slide) {
      if (slide !== null) {
        let splitedArray = slide.split('.')
        let lastValueOfArray = splitedArray[splitedArray.length - 1].split('?')[0]
        return (lastValueOfArray === 'mp4' || lastValueOfArray === 'flv' || lastValueOfArray === 'm4a' || lastValueOfArray === '3gp' || lastValueOfArray === 'mkv' || lastValueOfArray === 'mov' || lastValueOfArray === 'mkv')
      }
      return false
    },
    inspectionRoute() {
      if(this.count.actionable) {
        if (this.$route.query.src) {
        this.$router.push({name: 'services', query: { src: this.$route.query.src }})
        }else {
        this.$router.push({name: 'services' })
        }
      } else {
       this.getTax()
       if (this.$route.query.src) { 
       this.$router.push({ name: 'summary', query: { src: this.$route.query.src } })
       } else {
       this.$router.push({ name: 'summary' })
       }
      }
    },
    viewInspectionReport () {
      window.open(this.inspectionReportUrl)
    },
    nextSlide: function() {
      this.current++;
      console.log(this.current)
      if (this.current >= (this.inspectionLevelMedia || this.inspectionLevelMediaUrls).length) {
        this.current = 0;
      }
    },
    prevSlide: function() {
      this.current--;
      console.log(this.current)
      if (this.current < 0) {
        this.current = (this.inspectionLevelMedia || this.inspectionLevelMediaUrls).length - 1;
      }
    }
  },
    ...mapMutations([
      'logEvent',
      'setInspectionLevelMediaUrl',
      'setInspectionLevelMediaUrls'
    ])
})
</script>

<style scoped lang="scss">
.background {
  width: 100%;
  min-height: 100%;
  background-color: var(--grey-light-background);
  display: flex;
  flex-direction: column;
  align-items: center;
  .inspectionText {
    text-align: center;
  }

  .video-icon {
    content: url("data:image/svg+xml,%3Csvg width='42' height='42' viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='42' height='42' fill='%23F5F7FA'/%3E%3Cpath d='M4.5 37.0501C4.51077 37.6752 4.69265 38.2853 5.02586 38.8142C5.35907 39.3431 5.83088 39.7706 6.39 40.0501C6.94832 40.3656 7.57872 40.5314 8.22 40.5314C8.86128 40.5314 9.49168 40.3656 10.05 40.0501L36 24.0001C36.5646 23.7281 37.041 23.3023 37.3744 22.7716C37.7078 22.2409 37.8847 21.6269 37.8847 21.0001C37.8847 20.3734 37.7078 19.7594 37.3744 19.2287C37.041 18.698 36.5646 18.2721 36 18.0001L10.05 2.07012C9.49168 1.75465 8.86128 1.58887 8.22 1.58887C7.57872 1.58887 6.94832 1.75465 6.39 2.07012C5.83088 2.34968 5.35907 2.77715 5.02586 3.30606C4.69265 3.83497 4.51077 4.44509 4.5 5.07012V37.0501Z' fill='%23E0E5EE'/%3E%3C/svg%3E%0A");
  }

  .visibilty-yes {
    visibility: visible;
  } 
   .visibility-no {
    visibility: hidden;
   }

  .contents {
    width: 100%;
    max-width: 350px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    @media (min-height: 768px) {
      justify-content: flex-start;
    }
    .icon{
      width: 30px;
    }
    .item {
      display: flex;
      align-items: center;
      padding: 1em;
      border: none;
      font-weight: 600 ;
      //background-color: var(--white);
      font-size: 1.5rem;
      cursor: pointer;
      color: var(--blue);
      text-decoration: underline;
     }
    .text {
      margin: 1rem;
      text-align: center;
      .regular {
        font-size: 0.5em;
      }
    }
    .card {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem;
      background-color: var(--white);
      border-radius: 3px;
      box-shadow: var(--shadow);
      @media (min-width: 768px) {
        width: auto;
      }
    }
    .avatar {
      max-width: 70px;
      max-height: 70px;
      margin-right: 1rem;
      border-radius: 50%;
    }
    .consultant__name {
      display: block;
      font-weight: 700;
    }

    .time {
      font-weight: 700;
      .number {
        color: var(--blue);
      }
    }

    .clock__background {
      display: flex;
      align-items: center;
      margin-right: 2rem;
      padding: 1rem;
      border-radius: 50%;
      background-color: var(--grey-light-background);
    }
    .clock {
      max-width: 2rem;
      max-height: 2rem;
    }
    .pickup__time {
      font-weight: 700;
    }
    .button {
      margin: 2rem 0 0 0;
    }
  }
  #slider{
  
     display: flex; 
    //  height: 200px;
    align-items: center;
}

.slide-number {
  padding: 24px 0px;
  color: #1A1C21;
  font-size: 22px;
  font-weight: 700;
  line-height: 32px;
  word-wrap: break-word
}

.right-arrow {
    cursor: pointer;
    margin-left: 24px;
    content: url("data:image/svg+xml,%3Csvg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.964289 25.085C0.365042 24.513 0.34296 23.5635 0.914969 22.9643L10.0968 13.3452C10.2812 13.152 10.2812 12.848 10.0968 12.6548L0.914968 3.03571C0.342959 2.43646 0.365041 1.48697 0.964288 0.914965C1.56354 0.342956 2.51303 0.365038 3.08503 0.964285L12.2669 10.5833C13.5579 11.9358 13.5579 14.0642 12.2669 15.4167L3.08504 25.0357C2.51303 25.635 1.56354 25.657 0.964289 25.085Z' fill='%23343741'/%3E%3C/svg%3E%0A");
  }

  .left-arrow {
    cursor: pointer;
    margin-right: 24px;
    content: url("data:image/svg+xml,%3Csvg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.0357 25.085C13.635 24.513 13.657 23.5635 13.085 22.9643L3.90321 13.3452C3.71878 13.152 3.71878 12.848 3.90321 12.6548L13.085 3.03571C13.657 2.43646 13.635 1.48697 13.0357 0.914965C12.4365 0.342956 11.487 0.365038 10.915 0.964285L1.73314 10.5833C0.442136 11.9358 0.442135 14.0642 1.73314 15.4167L10.915 25.0357C11.487 25.635 12.4365 25.657 13.0357 25.085Z' fill='%23343741'/%3E%3C/svg%3E%0A");
  }
 

.slider {
  cursor: pointer;
  margin: 0 auto;
  padding: 0;
  width: 200px;
  height: 150px;
  position: relative;
  overflow: hidden; 
  ul.slides {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: table;
    position: absolute;
    top: 0;
    transition: left 800ms;

    li {
      list-style-type: none;
      display: table-cell;
      img {
        width: 200px;
        height: 150px;
        background-size: cover;
      }
      video {
        width: 200px;
        height: 150px;
        background-size: cover;
      }
      
    }
  }

  .media-service {
    width: 200px;
  }
 

  .prev,
  .next{
    // text-decoration: none;
    // color: #fff;
    // position: absolute;  
    // z-index: 1;
    // font-size: 42px;
    // top: 43%;
    // text-shadow: 2px 2px 5px rgba(0,0,0,0.5);
  }
  .prev{
    left: 20px;
  }
  .next{
    right: 20px;
  }
} 

}
</style>
